/**
 * qr-base-url.ts
 *
 * The one place the per-item QR payload URL's base is decided.
 *
 * A QR code has to encode an ABSOLUTE url — the phone scanning it has no page to
 * resolve a relative one against — so every surface that renders or requests a QR
 * needs this value, and until now each picked its own environment key: the desktop
 * form used `appUrl`, mobile and reprint used `qrLogReaderUrl`. Those keys are
 * identical in local, UAT and production, which is exactly why the divergence went
 * unnoticed: `environment.dev.ts` defines only `appUrl`, so on a dev build the
 * reprint and mobile paths were handed `undefined` and their QR codes could not be
 * built at all.
 *
 * Two keys because they answer different questions — `appUrl` is where this build
 * lives, `qrLogReaderUrl` is where a scanned label should send someone, and on a
 * pilot build those can legitimately differ (a pilot label should open the pilot
 * app). So the preference order is kept, and only the fallback is new.
 */

import { environment } from '../../../environments/environment';

/** The base URL per-item QR payloads are built on. */
export const QR_BASE_URL: string =
  (environment as { qrLogReaderUrl?: string }).qrLogReaderUrl?.trim()
  || (environment as { appUrl?: string }).appUrl?.trim()
  || '';
